import useAppInstall from './useAppInstall';

export default useAppInstall;
